import { AppContextProps } from "../containers/context/Context";

export const useAccessControl = (permission: string | string[], context: AppContextProps) => {
    const { rootState } = context;
    
    permission = Array.isArray(permission) ? permission : [permission]
    
    if(rootState.userInfo && !rootState.userInfo.superUser) {
        return rootState.userInfo.permissionKeys.some((permissionKey) => permission.includes(permissionKey))
    }
    
    return true;
}